import React, { useEffect, useState } from "react";
import isEmpty from "lodash.isempty";

import { useActions } from "src/hooks/useActions";
import { authProfile } from "src/actions/auth";
import { getGiftForm, getExtraUserInfo } from "src/actions/questionnaire";
import Context from "./Context";
import { useLiff } from "src/providers/Liff";
import { stage, lineOAUrl } from "src/config";
import Loading from "src/components/Loading";

// 對應表單 genderList 的實際 radio 值 (src/containers/Questionnaire/define.js)
const RSVP_GENDER_MAP = { M: "先生", F: "小姐" };

async function getClientProfiles(
  liff,
  actionGetGiftForm,
  actionGetExtraUserInfo,
) {
  try {
    const profile = await liff.getProfile().catch((error) => {
      liff.logout();
      liff.login({ redirectUri: window.location.href });
      return false;
    });
    const profilePlus = liff.getDecodedIDToken() || {};
    const giftCustomerResp = await actionGetGiftForm({
      userId: profile.userId,
    });
    if (giftCustomerResp && giftCustomerResp.status === 200) {
      const {
        phone,
        firstName,
        lastName,
        name,
        birthday,
        email,
        fillinBranch,
        nameTitle,
      } = giftCustomerResp.data;
      profile.phone = phone;
      profile.firstName = firstName || name;
      profile.lastName = lastName;
      if (birthday) {
        const [year, month, day] = birthday.split("/");
        profile.birthdayYear = year;
        profile.birthdayMonth = month;
        profile.birthdayDay = day;
      }
      if (nameTitle) profile.gender = nameTitle;
      if (email) profile.email = email;
      if (fillinBranch) profile.store = fillinBranch;
    } else {
      profile.phone = (profilePlus.phone_number || "").replace("+886", "0");
      profile.firstName = profile.displayName;
    }

    // 三方 (RSVP) 資料優先度高於上方 event-form 資料，若存在則覆蓋對應欄位
    const extraUserInfoResp = await actionGetExtraUserInfo({
      userId: profile.userId,
    });
    if (
      extraUserInfoResp &&
      extraUserInfoResp.status === 200 &&
      !isEmpty(extraUserInfoResp.data)
    ) {
      const { name, phone, email, gender, birthday } = extraUserInfoResp.data;
      if (name) {
        profile.lastName = name.charAt(0);
        profile.firstName = name.slice(1);
      }
      if (phone) profile.phone = phone;
      if (email) profile.email = email;
      if (gender) profile.gender = RSVP_GENDER_MAP[gender] || gender;
      if (birthday) {
        const [year, month, day] = birthday.split(/[-/]/);
        profile.birthdayYear = year;
        profile.birthdayMonth = String(Number(month));
        profile.birthdayDay = String(Number(day));
      }
    }

    if (!profile) return { error: true };
    const userId = profile.userId;
    const accessToken = liff.getAccessToken();

    return { profile, accessToken, userId };
  } catch (error) {
    return { error };
  }
}

let refreshingClient = false;
const Provider = ({ children }) => {
  const [auth, setAuth] = useState({});
  const [profile, setProfile] = useState({});
  const [fetched, setFetched] = useState(false);
  const { liff, ready } = useLiff();
  const [actionAuth, actionGetGiftForm, actionGetExtraUserInfo] = useActions([
    authProfile,
    getGiftForm,
    getExtraUserInfo,
  ]);
  const searchParams = new URLSearchParams(window.location.search);
  const env = searchParams.get("env");
  // const location = useLocation();

  const validAuth = auth.userId && auth.accessToken && !isEmpty(profile);

  const refreshClient = async () => {
    if (refreshingClient) return;
    refreshingClient = true;
    const { profile, accessToken, userId, error } = await getClientProfiles(
      liff,
      actionGetGiftForm,
      actionGetExtraUserInfo,
    );
    refreshingClient = false;
    if (isEmpty(profile) || error) {
      return { err: true };
    }
    actionAuth(profile);
    setProfile(profile);
    setAuth({ accessToken, userId });
    return { err: false };
  };

  const init = async () => {
    await refreshClient();
    setFetched(true);
  };

  useEffect(() => {
    console.log(liff, ready);
    if (!liff || !ready) return;

    const isLocal = [stage, env].includes("local");
    if (!isLocal && !liff.isInClient())
      return window.location.replace(lineOAUrl);

    if (!isLocal && !liff.isLoggedIn()) {
      return liff.login({ redirectUri: window.location.href });
    }

    async function checkFriendShip() {
      if (isLocal) return init();

      const res = await liff.getFriendship();
      console.log("isFriendship", res);
      if (!res.friendFlag) window.location.replace(lineOAUrl);
      else init();
    }
    if (isEmpty(auth)) checkFriendShip();
  }, [liff, ready]);

  const props = {
    auth,
    profile,
    validAuth,
  };

  return (
    <Context.Provider value={{ ...props }}>
      {fetched ? children : <Loading />}
    </Context.Provider>
  );
};

export default Provider;
